/** The connector's Lambda function name, which is also its AWS image name.
 * Its Cloud Run service keeps `connectorName`. */
export const toLambdaFunctionName = (connectorName: string) =>
  `${connectorName}-aws`;
